import { format } from "date-fns";

import PresentsFolios from "../components/PresentsFolios";
import { getViewFields } from "componentsv2/tools/functions";
import { layout as layoutFolio } from "../models/folio";
import proxy from "api/proxy";

function Presents({ globalSearch }) {
  const layout = layoutFolio();

  async function getFolios(location, wordsSearch) {
    const today = format(new Date(), "yyyy-MM-dd");
    console.log("today >>> ", today);
    const fieldsNames = getViewFields(layout, "cards");
    fieldsNames.push("booking.payments");
    fieldsNames.push("check_out_time");
    fieldsNames.push("booking.party.name");
    const orderBy = [["room.code", "ASC"]];
    const dom = [
      ["registration_state", "=", "check_in"],
      ["arrival_date", "<=", today],
      ["departure_date", ">=", today],
    ];

    if (wordsSearch.value) {
      dom.push([
        "OR",
        ["room.code", "ilike", `%${wordsSearch.value}%`],
        ["main_guest.name", "ilike", `%${wordsSearch.value}%`],
        ["main_guest.id_number", "ilike", `%${wordsSearch.value}%`],
        ["vehicle_plate", "ilike", `%${wordsSearch.value}%`],
      ]);
    }

    if (location.value) {
      dom.push(["room.location", "=", location.value]);
    }

    const { data } = await proxy.search(
      "hotel.folio",
      dom,
      fieldsNames,
      null,
      orderBy,
    );
    return data;
  }

  return <PresentsFolios getFolios={getFolios} queryKey="foliosCurrents" />;
}

export default Presents;
